'use client';
import { useState, useRef, useEffect } from 'react';

function attachMediaListener(query, callback) {
  try {
    query.addEventListener("change", callback);
    return () => query.removeEventListener("change", callback);
  } catch (e) {
    query.addListener(callback);
    return () => query.removeListener(callback);
  }
}
function getInitialValue(query, initialValue) {
  if (typeof window !== "undefined" && "matchMedia" in window) {
    return window.matchMedia(query).matches;
  }
  return false;
}
function useMediaQuery(query, initialValue, { getInitialValueInEffect } = {
  getInitialValueInEffect: true
}) {
  const [matches, setMatches] = useState(
    getInitialValueInEffect ? initialValue : getInitialValue(query)
  );
  useEffect(() => {
    if ("matchMedia" in window) {
      try {
        const mediaQuery = window.matchMedia(query);
        setMatches(mediaQuery.matches);
        return attachMediaListener(mediaQuery, (event) => setMatches(event.matches));
      } catch (e) {
        // Safari iframe compatibility issue
        console.warn('MediaQuery not available in iframe:', e);
        return void 0;
      }
    }
    return void 0;
  }, [query]);
  return matches || false;
}

export { useMediaQuery };
//# sourceMappingURL=use-media-query.mjs.map
